import React from "react";

import { MessageListItem } from "./shared";

type MessageItemProps = {
  name: string;
  time: string;
  read: boolean;
  active: boolean;
  message: string;
  selected: boolean;
  conversationType: "PATIENT" | "LEAD";
  handleOnPress: () => void;
};

const MessageItem: React.FC<MessageItemProps> = ({
  name,
  time,
  read,
  message,
  selected,
  conversationType,
  handleOnPress,
}) => {
  const formatDateTime = (dateString: string) => {
    const date = new Date(`${dateString}Z`);
    const now = new Date();
    const timeDifference = now.getTime() - date.getTime();
    const oneDay = 24 * 60 * 60 * 1000;

    if (timeDifference < oneDay) {
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }

    return date.toLocaleDateString([], { month: "short", day: "numeric" });
  };

  const isMessageActive = (lastMessageAt: string) => {
    const lastMessageTime = new Date(`${lastMessageAt}Z`).getTime();
    return Date.now() - lastMessageTime < 30 * 60 * 1000;
  };

  return (
    <MessageListItem
      title={name}
      preview={message}
      timestamp={formatDateTime(time)}
      selected={selected}
      unread={!read}
      onPress={handleOnPress}
      accessibilityLabel={`Open conversation with ${name}`}
      showActiveBadge={isMessageActive(time)}
      categoryLabel={conversationType === "LEAD" ? "Lead" : "Patient"}
      categoryTone={conversationType === "LEAD" ? "lead" : "patient"}
    />
  );
};

export default MessageItem;
